import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import Healthcare_Section1 from "./sections/Healthcare_Section1";

function HealthcareCleaning() {
  usePageMeta({
    title: "Healthcare Cleaning Services Ireland | Spechs",
    description:
      "Specialist healthcare and medical facility cleaning across Ireland. Fully compliant and hygienic.",
    canonical: "https://www.spechs.ie/cleaning/healthcare/",
  });
  return (
    <SubPageLayout title="Healthcare & Medical Facility Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Healthcare_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default HealthcareCleaning;
